import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ARTICLES } from "@/data/insights";
import { Reveal, SectionHeader } from "@/components/Reveal";

const Insights = () => {
    const featured = ARTICLES.find((a) => a.featured) || ARTICLES[0];
    const rest = ARTICLES.filter((a) => a.slug !== featured.slug);

    return (
        <section id="insights" data-testid="insights-section" className="t-bg-alt py-14 md:py-24">
            <div className="container-x">
                <Reveal>
                    <SectionHeader
                        eyebrow="Insights"
                        title="Thinking that moves technology forward"
                        intro="Field notes from the architects doing the work — written for both boardrooms and engine rooms."
                    />
                </Reveal>

                <div className="mt-14 grid gap-6 lg:grid-cols-2">
                    <Reveal>
                        <Link
                            to={`/insights/${featured.slug}`}
                            data-testid="insight-featured"
                            className="group relative flex h-full min-h-[380px] flex-col justify-end overflow-hidden rounded-2xl border t-border transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-electric/40"
                        >
                            <img
                                src={featured.visual}
                                alt=""
                                loading="lazy"
                                className="absolute inset-0 h-full w-full object-cover opacity-60 transition-transform duration-700 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/70 to-navy-950/20" />
                            <div className="relative p-9">
                                <span className="eyebrow">{featured.category}</span>
                                <h3 className="mt-4 max-w-lg font-display text-2xl font-semibold leading-snug t-heading md:text-3xl">
                                    {featured.title}
                                </h3>
                                <p className="mt-4 max-w-lg text-sm leading-relaxed t-soft">{featured.excerpt}</p>
                                <div className="mt-6 flex items-center justify-between border-t t-border pt-5">
                                    <p className="font-mono text-[11px] uppercase tracking-[0.18em] t-faint">
                                        {featured.date} · {featured.readTime}
                                    </p>
                                    <ArrowUpRight size={18} className="text-electric transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
                                </div>
                            </div>
                        </Link>
                    </Reveal>

                    <div className="flex flex-col gap-6">
                        {rest.map((a, i) => (
                            <Reveal key={a.slug} delay={0.1 + i * 0.08}>
                                <Link
                                    to={`/insights/${a.slug}`}
                                    data-testid={`insight-card-${i + 1}`}
                                    className="group flex h-full items-start justify-between gap-6 rounded-2xl border t-border t-surface p-7 transition-[transform,border-color,background-color] duration-300 hover:-translate-y-1 hover:border-electric/40 t-hoverbg"
                                >
                                    <div>
                                        <span className="eyebrow !text-[10.5px]">{a.category}</span>
                                        <h3 className="mt-2.5 font-display text-lg font-semibold leading-snug t-heading transition-colors group-hover:text-electric md:text-xl">
                                            {a.title}
                                        </h3>
                                        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] t-faint">
                                            {a.date} · {a.readTime}
                                        </p>
                                    </div>
                                    <ArrowUpRight
                                        size={18}
                                        className="mt-1 shrink-0 t-faint transition-[color,transform] duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-electric"
                                    />
                                </Link>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Insights;
